import { render, staticRenderFns } from "./AdminUser.vue?vue&type=template&id=22668102"
import script from "./AdminUser.js?vue&type=script&lang=js&external"
export * from "./AdminUser.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports